
import AuthCardContainer from './AuthCardContent';
import RegisterForm from './Components/RegisterForm';
const Register = () => {
  return (
    <AuthCardContainer>
      <RegisterForm />
    </AuthCardContainer>
  );
}

export default Register;